import { create } from "zustand";

export const PLOT_PRESETS = [
  { id: "default", name: "剧情演化 v31", path: "default.json" },
  { id: "experimental", name: "剧情演化指导 v185", path: "剧情演化指导 试验版.json" },
  { id: "direction", name: "剧情演化 v1（方向驱动）", path: "剧情演化-v1（方向驱动）.json" },
  { id: "director-collaboration", name: "剧情演化·导演协同版", path: "剧情演化-导演协同版.json" },
] as const;

export interface PlotEvolutionConfig {
  enabled: boolean;
  frequency: number;
  activePresetId: string;
  directorEnabled: boolean;
}
const key = "mh-rp-plot-evolution-v1";
const stored = (() => {
  try {
    return JSON.parse(localStorage.getItem(key) ?? "{}") as Partial<PlotEvolutionConfig>;
  } catch {
    return {};
  }
})();
interface State extends PlotEvolutionConfig {
  setConfig: (patch: Partial<PlotEvolutionConfig>) => void;
}
export const usePlotEvolutionStore = create<State>((set) => ({
  enabled: stored.enabled ?? false,
  frequency: Math.max(1, Math.trunc(stored.frequency ?? 1)),
  activePresetId: stored.activePresetId ?? "default",
  directorEnabled: stored.directorEnabled ?? true,
  setConfig: (patch) =>
    set((state) => {
      const next = { ...state, ...patch };
      localStorage.setItem(
        key,
        JSON.stringify({
          enabled: next.enabled,
          frequency: next.frequency,
          activePresetId: next.activePresetId,
          directorEnabled: next.directorEnabled,
        }),
      );
      return next;
    }),
}));
